var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRectangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 826,
    height: 757,
    viewBox: "0 0 826 757",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 826,
    height: 757,
    fill: "url(#pattern0)",
    fillOpacity: 0.07
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 0.0968523,
    height: 0.10568
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_839_2001",
    transform: "scale(0.00121065 0.001321)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_839_2001",
    width: 80,
    height: 80,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJRSURBVHgB7dw/UsJAFAbwl3ARLQKUegNt+Te5gXgTvYE3UDtLhYSxQ2+gJaTRixD3YdYJy+4GbPbN5Ps1QBKab5bZhHybaDQalVSJ43g6m80eCZwmk8nVZrN50J/j+k7ewQcQWJnhsdg8CCHa2cJjcRRF1+ZGhLjLFR5n11mv1x+9Xu9bfU7rO8uyTPv9/tdqtfqkFvOFN5/PHyK9YTweT1Vo9+aB6svni8Xig1pITbAX6mVpbtfh8fuO3ugYibd5nj9RS6lMvpIkOVWBnelt9fBYx/hCPcTbLMtuqOWKonjWIZrhOaVpekawo/o5AwAAAAAAAAAAAAAAAEB7HXPbcDAYiLnt2iEBhsPhvbppfXdIF6cqPb12u10uArxTYMEDrMKb8vumQpNR9LmQEGJEAbnKO7amrKslFbr8FHQEcnnnkGqdr2KW5/krBRR0BGquah2PRH719fMoMBEBMleINlLCYyJmYeZqypokhcfEBMiaQpQWHotJGBVS+Z99oYgaga7ZVpNYfBcTYFN4mrQQRczCvvM8fnWd4khYlhZ8BDatw5C+jkXkpZxttvWcJ15mWfZGgQS/lGtah1E7dm8kqkAf1aXcHQUU/Cd8zDqMeohVeFOCX8f8oYo1GwAAAAAAAAAAAAAAAACth9uG+1yZ7PUDq3UYS15+QLBVZbG0PZh3p5lQL/pwUyBJkpOiKF6oxZrWsfyVizz9vKDlnZAOWceyHYG+ipkK75la6pB1LFFTP4/Au44lRnjNtg/cdjzxfW8WRnh2rhB3AkR4frYQfwDd1q/gDe/GLgAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.087fc72d95315e7670ddfeddcf1e6fad.svg";
export { ForwardRef as ReactComponent };